import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './core/auth/auth.module';
import { MY_DATE_FORMATS } from './core/config/dateFormats';
import { MatPaginatorIntlDe } from './core/config/matPaginationDe';
import { CoreModule } from './core/core.module';
import { AlertComponent } from './core/layout/dialog/alert/alert.component';
import { LoaderComponent } from './core/layout/dialog/loader/loader.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ClaimEditComponent } from './pages/admin/sub-pages/customers/components/customer-edit/components/claim-edit/claim-edit.component';
import { InvitationDialogComponent } from './pages/admin/sub-pages/customers/components/customer-edit/components/claim-edit/components/invitation-dialog/invitation-dialog.component';
import { CustomerEditComponent } from './pages/admin/sub-pages/customers/components/customer-edit/customer-edit.component';
import { CustomerSearchComponent } from './pages/admin/sub-pages/customers/components/customer-search/customer-search.component';
import { CustomersViewComponent } from './pages/admin/sub-pages/customers/customers-view.component';
import { LogDialogComponent } from './pages/admin/sub-pages/logs/components/log-dialog/log-dialog.component';
import { LogsComponent } from './pages/admin/sub-pages/logs/logs.component';
import { Claim2userComponent } from './pages/admin/sub-pages/users/sub-pages/user-edit/components/claim2user/claim2user.component';
import { CustomersComponent } from './pages/admin/sub-pages/users/sub-pages/user-edit/components/customers/customers.component';
import { UserEditComponent } from './pages/admin/sub-pages/users/sub-pages/user-edit/user-edit.component';
import { UserSearchComponent } from './pages/admin/sub-pages/users/sub-pages/user-search/user-search.component';
import { UsersViewComponent } from './pages/admin/sub-pages/users/users-view.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { DomainEditComponent } from './pages/admin/sub-pages/customers/components/customer-edit/components/domain-edit/domain-edit.component';
import { TabContentComponent } from './pages/admin/sub-pages/customers/components/customer-edit/components/tab-content/tab-content.component';
import { HistoryDialogComponent } from './pages/admin/sub-pages/users/sub-pages/user-edit/components/history-dialog/history-dialog.component';
import { CreateUserDialogComponent } from './pages/admin/sub-pages/users/sub-pages/user-search/components/create-user-dialog/create-user-dialog.component';

registerLocaleData(localeDe, 'de-DE');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdminComponent,
    UserSearchComponent,
    UserEditComponent,
    NotFoundComponent,
    Claim2userComponent,
    LogsComponent,
    CustomersComponent,
    LogDialogComponent,
    CustomersViewComponent,
    CustomerSearchComponent,
    CustomerEditComponent,
    UsersViewComponent,
    ClaimEditComponent,
    InvitationDialogComponent,
    DomainEditComponent,
    TabContentComponent,
    HistoryDialogComponent,
    CreateUserDialogComponent
  ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        NoopAnimationsModule,
        CoreModule,
        AuthModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSidenavModule,
        MatButtonModule,
        MatMenuModule,
        MatTreeModule,
        MatCardModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatTooltipModule,
        MatListModule,
        MatIconModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDialogModule,
        MatTableModule,
        MatSortModule,
        MatTabsModule
    ],
  entryComponents: [
    LoaderComponent,
    AlertComponent,
    LogDialogComponent,
    InvitationDialogComponent,
    HistoryDialogComponent,
    CreateUserDialogComponent
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de-DE'},
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 3000, verticalPosition: 'top', panelClass: 'accent'}},
    {provide: MatPaginatorIntl, useClass: MatPaginatorIntlDe},
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
// @ts-ignore
export class AppModule {
}
